import React, { forwardRef, memo } from 'react'

const CloseCircleIcon = forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>((props, ref) => (
  <svg
    ref={ref}
    width={56}
    height={56}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 80 81"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <circle
      cx="40"
      cy="40.093"
      r="38.387"
      fill="#fff"
      stroke="#eee"
      strokeWidth={3.227}
    />
    <path
      d="M44 36.093 36 44.093M36 36.093 44 44.093"
      stroke="#78BE20"
      strokeWidth={2}
    />
    <path
      d="M40 52.093c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Z"
      stroke="#78BE20"
      strokeWidth={2}
    />
  </svg>
))

CloseCircleIcon.displayName = 'CloseCircleIcon'
export default memo(CloseCircleIcon)
